import { getStudentRouteSearch } from '@openeducation/hr-js-utils';
import { type HRHeadingProps, useAllStudentsList } from '@openeducation/hr-rn-components';
import type { StudentSelectHandler } from '@openeducation/hr-rn-shared-types';

import { OMPath, OEPath, useNavigate } from '../router';

export const useStudentsListProps = (
  pathname: OEPath | OMPath
): NonNullable<HRHeadingProps['studentsListProps']> => {
  const { data } = useAllStudentsList();
  const navigate = useNavigate();

  const onStudentSelect: StudentSelectHandler = (contactId, ownerPurchaserId) => {
    navigate({
      pathname,
      search: getStudentRouteSearch(contactId, ownerPurchaserId),
    });
  };

  return {
    data,
    onStudentSelect,
  };
};
